export default __webpack_public_path__ + "static/media/agent_disabled.b74c2111.svg";